import React from 'react';
import { Box, Typography } from '@mui/material';

interface NutritionValues {
  kcal: number | null;
  protein: number | null;
  fat: number | null;
  carbs: number | null;
  fiber: number | null;
}

interface NutritionCellsProps {
  nutrition: NutritionValues;
  sx?: object;
}

const CELLS = [
  { key: 'kcal',    label: 'ккал',    unit: '',   color: '#F57C00' },
  { key: 'protein', label: 'Білки',   unit: ' г', color: '#1976D2' },
  { key: 'fat',     label: 'Жири',    unit: ' г', color: '#FBC02D' },
  { key: 'carbs',   label: 'Вуглев.', unit: ' г', color: '#388E3C' },
  { key: 'fiber',   label: 'Клітк.',  unit: ' г', color: '#795548' },
] as const;

export const NutritionCells: React.FC<NutritionCellsProps> = ({ nutrition, sx }) => (
  <Box sx={{ display: 'flex', gap: 1, p: 1.5, bgcolor: 'action.hover', borderRadius: 1, ...sx }}>
    {CELLS.map(({ key, label, unit, color }) => {
      const value = nutrition[key];
      return (
        <Box key={key} sx={{ flex: 1, textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
          <Typography variant="body2" fontWeight={600} sx={{ color }}>
            {value != null ? `${value}${unit}` : '—'}
          </Typography>
        </Box>
      );
    })}
  </Box>
);
